<template>
  <div class="header">
    <div class="header_nav">
      <div class="logo" v-show="curNav == 1">
        <img src="../assets/logo-txt.png" alt="" />
      </div>
      <div class="logo_img" v-show="curNav != 1">
        <img src="../assets/logo.png" alt="" class="logo" />
      </div>
      <div class="list">
        <ul>
          <li
            v-for="(item, index) of navList"
            :key="index"
            :class="{ active: curNav === index + 1 }"
            @mouseenter="onhandleShowMask(item)"
            @mouseleave="onhandleHideMask"
            @click="onhandleLink(index)"
          >
            <a :href="item.url">
              <span>{{ item.name }}</span>
              <span>{{ item.english_name }}</span>
            </a>
          </li>
        </ul>
        <div class="search">
          <input
            placeholder="输入型号"
            v-model="searchValue"
            @keyup.enter="onhandleShowModal"
          />
          <img src="../assets/key.png" alt="" @click="onhandleShowModal" />
        </div>
      </div>
    </div>
    <div
      class="mask"
      :class="{ show: showMask }"
      @mouseenter="onhandleshowMask"
      @mouseleave="onhandleHideMask"
    >
      <ul v-if="showMask && english_name === 'Introduction'">
        <li>
          <a href="#introduction">公司概要 / 沿革</a>
        </li>
        <li>
          <a href="#origin">公司名称由来</a>
        </li>
      </ul>
      <ul v-if="showMask && english_name === 'About US'">
        <li>
          <router-link to="/" target="_blank">合作优势</router-link>
        </li>
        <li>
          <router-link to="/contentUS" target="_blank">联系我们</router-link>
        </li>
      </ul>
      <ul
        v-if="
          showMask &&
          (english_name === 'Tech Center' ||
            english_name === 'Download' ||
            english_name === 'Tech-Support')
        "
      >
        <li>
          <router-link to="/techCenter/1" target="_blank">
            <img src="../assets/j1.png" alt="" />
            <span>齿轮问答</span>
          </router-link>
        </li>
        <li>
          <router-link to="/techCenter/2" target="_blank">
            <img src="../assets/j2.png" alt="" />
            <span>图纸下载</span>
          </router-link>
        </li>
        <li>
          <router-link to="/techCenter/3" target="_blank">
            <img src="../assets/j3.png" alt="" />
            <span>计算公式</span>
          </router-link>
        </li>
        <li>
          <router-link to="/techCenter/4" target="_blank">
            <img src="../assets/j4.png" alt="" />
            <span>齿轮应用</span>
          </router-link>
        </li>
      </ul>
      <ul v-if="showMask && english_name === 'Products'">
        <li v-for="item of productsTypeList" :key="item.id">
          <router-link :to="'/products/' + item.id" target="_blank">
            <img :src="item.product_type_image_address" alt="" />
            <div class="name">
              <span>{{ item.product_type_name }}</span>
              <span>{{ item.product_type_name_english }}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import request from '../server/request';

export default {
  name: "mb-header",
  data() {
    return {
      curNav: 1,
      showMask: false,
      // showModal: false,
      searchValue: "",
      navList: [
        {
          url: "#home",
          name: "首页",
          english_name: "Home",
        },
        {
          url: "#introduction",
          name: "企业介绍",
          english_name: "Introduction",
        },
        {
          url: "#products",
          name: "专营产品",
          english_name: "Products",
        },
        // {
        //   url: "#techCenter",
        //   name: "图纸下载",
        //   english_name: "Download",
        // },
        {
          url: "#techCenter",
          name: "技术支持",
          english_name: "Tech-Support",
        },
        {
          url: "#importExport",
          name: "资质证明",
          english_name: "Certification",
        },
        {
          url: "#partner",
          name: "合作伙伴",
          english_name: "Partner",
        },
        {
          url: "#aboutUs",
          name: "关于我们",
          english_name: "About US",
        },
      ],
      titleText: "图纸",
      english_name: "",
      productsTypeList: [
        {
          id: 1,
          product_type_image_address: require("../assets/z01.png"),
          product_type_name: "正齿轮",
          product_type_name_english: "Spur Gears",
        },
        {
          id: 2,
          product_type_image_address: require("../assets/z02.png"),
          product_type_name: "斜齿齿轮",
          product_type_name_english: "Helical Gears",
        },
        {
          id: 3,
          product_type_image_address: require("../assets/z03.png"),
          product_type_name: "内齿轮",
          product_type_name_english: "Internal Gears",
        },
        {
          id: 4,
          product_type_image_address: require("../assets/z04.png"),
          product_type_name: "等径锥齿轮",
          product_type_name_english: "Miter Gears",
        },
        {
          id: 5,
          product_type_image_address: require("../assets/z05.png"),
          product_type_name: "锥齿轮",
          product_type_name_english: "Bevel Gears",
        },
        {
          id: 6,
          product_type_image_address: require("../assets/z06.png"),
          product_type_name: "交错轴齿轮",
          product_type_name_english: "Screw Gears",
        },
        {
          id: 8,
          product_type_image_address: require("../assets/z07.png"),
          product_type_name: "齿条",
          product_type_name_english: "Racks",
        },
        {
          id: 9,
          product_type_image_address: require("../assets/z08.png"),
          product_type_name: "CP齿条&齿轮",
          product_type_name_english: "CP Rack&Pinion",
        },
        {
          id: 10,
          product_type_image_address: require("../assets/z09.png"),
          product_type_name: "蜗杆蜗轮",
          product_type_name_english: "Worm Gears",
        },
        {
          id: 11,
          product_type_image_address: require("../assets/z10.png"),
          product_type_name: "齿轮箱",
          product_type_name_english: "Gears Boxes",
        },
        {
          id: 13,
          product_type_image_address: require("../assets/z11.png"),
          product_type_name: "其他产品",
          product_type_name_english: "Others",
        },
      ],
    };
  },
  methods: {
    loadData() {
      // request.getProductsType(res => {
      // 	this.productsTypeList = res.data
      // })
    },
    // closeModal() {
    // 	const dom = document.getElementById('modal');
    // 	if(dom) {
    // 		if(!dom.contains(event.target)) {
    // 			this.showModal = false;
    // 		}
    // 	}
    // },
    onhandleShowMask(item) {
      this.showMask = true;
      this.english_name = item.english_name;
      switch (item.english_name) {
        case "Home":
          this.showMask = false;
          break;
        case "Certification":
          this.showMask = false;
          break;
        case "Partner":
          this.showMask = false;
          break;
        case "Import / Export":
          this.showMask = false;
          break;

        default:
          break;
      }
    },
    onhandleshowMask() {
      this.showMask = true;
    },
    onhandleHideMask() {
      this.showMask = false;
    },
    onhandleLink(index) {
      this.curNav = index + 1;
      this.showMask = false;
    },
    handleScroll() {
      const distance = document.documentElement.scrollTop;
      const ClientHeight = document.body.clientHeight;
      if (distance < ClientHeight) {
        this.curNav = 1;
      }
      if (ClientHeight * 1 < distance && distance < ClientHeight * 3) {
        this.curNav = 2;
      }
      if (ClientHeight * 3 < distance && distance < ClientHeight * 4) {
        this.curNav = 3;
      }
      if (ClientHeight * 4 < distance && distance < ClientHeight * 5) {
        this.curNav = 4;
      }
      if (ClientHeight * 5 < distance && distance < ClientHeight * 6) {
        this.curNav = 5;
      }
      if (ClientHeight * 6 < distance && distance < ClientHeight * 7) {
        this.curNav = 6;
      }
      if (ClientHeight * 7 <= distance && distance < ClientHeight * 8) {
        this.curNav = 7;
      }
    },
    onhandleShowModal() {
      if (!this.searchValue) {
        alert("请输入搜索内容");
      } else {
        window.open(
          "https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
            this.searchValue +
            "&lang=zh_CN",
          "_blank"
        );
        // this.showModal = true;
        // this.titleText = `${this.searchValue} 图纸`
        // const mainContent = document.getElementById('mainContent');
        // mainContent.src = 'https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=' + this.searchValue + '&lang=zh_CN'
      }
    },
  },
  created() {
    this.loadData();
    window.addEventListener("scroll", this.handleScroll, false);
    window.addEventListener("resize", this.resizeScroll, false);
  },
};
</script>

<style scoped lang='less'>
.header {
  position: relative;

  .header_nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 1.88rem;
    position: fixed;
    // overflow-x: auto;
    width: 100%;
    z-index: 100;
    .logo {
      display: flex;
      flex-direction: column;
      color: #fff;
      margin-left: 0.32rem;
      // width: 300px;
      .name {
        width: 100%;
        font-size: 24px;
      }
    }
    .logo_img {
      width: 200px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .list {
      height: 100%;
      display: flex;
      align-items: center;
      ul {
        display: flex;
        flex-direction: row;
        width: 750px;
        height: 100%;
        align-items: center;
        justify-content: center;
        li {
          display: flex;
          align-items: center;
          height: 100%;
          cursor: pointer;

          &:hover {
            a {
              color: #ffdc00;
            }
          }
          &.active {
            a {
              color: #ffdc00;
            }
          }
          a {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 0.26rem;
            font-size: 0.34rem;
            color: #fff;
          }
        }
      }
    }
    .search {
      width: 100px;
      margin-right: 30px;
      transition: width 0.3s;
      position: relative;
      &:hover {
        width: 168px;
      }
      input {
        padding: 0;
        width: 100%;
        border-radius: 5px;
        height: 0.58rem;
        border: 1px solid #fff;
        padding-left: 5px;
        background: none;
        color: #fff;
      }
      img {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
      }
      input::-webkit-input-placeholder {
        /*WebKit browsers*/
        color: #fff;
      }
    }
  }

  .mask {
    position: fixed;
    top: 1.88rem;
    z-index: 1001;
    width: 100%;
    background: rgba(40, 90, 140, 0.68);
    transition: all 0.3s;
    height: 0rem;
    &.show {
      transition: all 0.3s;
      height: 5rem;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      height: 100%;
      // padding: 0 150px;
      margin: 0 auto;
      width: 1280px;
      li {
        text-align: center;
        width: 198px;
        color: #fff;
        font-weight: 500;
        font-size: 0.34rem;
        border-bottom: 2px solid #eccb0f;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.2rem 0;
        cursor: pointer;
        &:nth-child(5) {
          img {
            padding-bottom: 15px;
          }
        }
        a {
          color: #fff;
          display: flex;
          align-items: center;
          span {
            margin-right: 10px;
          }
        }
        img {
          width: 48px;
          height: 48px;
        }
        .name {
          display: flex;
          margin-left: 10px;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
